{
    "May the force be with you": "Möge die Macht mit dir sein!",
    "Digit1": "1",
    "Digit2": "2",
    "Digit3": "3",
    "Digit4": "4",
    "Digit5": "5",
    "Digit6": "6",
    "Digit7": "7",
    "Digit8": "8",
    "Digit9": "9",
    "Digit0": "0",
    "KeyA": "A",
    "KeyB": "B",
    "KeyC": "C",
    "KeyD": "D",
    "KeyE": "E",
    "KeyF": "F",
    "KeyG": "G",
    "KeyH": "H",
    "KeyI": "I",
    "KeyJ": "J",
    "KeyK": "K",
    "KeyL": "L",
    "KeyM": "M",
    "KeyN": "N",
    "KeyO": "O",
    "KeyP": "P",
    "KeyQ": "Q",
    "KeyR": "R",
    "KeyS": "S",
    "KeyT": "T",
    "KeyU": "U",
    "KeyV": "V",
    "KeyW": "W",
    "KeyX": "X",
    "KeyY": "Y",
    "KeyZ": "Z",
    "Comma": ",",
    "Period": ".",
    "Semicolon": ";",
    "Quote": "'",
    "BracketLeft": "[",
    "BracketRight": "]",
    "Backquote": "`",
    "Backslash": "\\",
    "Minus": "-",
    "Equal": "=",
    "AltLeft": "Alt",
    "AltRight": "Alt",
    "CapsLock": "Feststelltaste",
    "ControlLeft": "Strg",
    "ControlRight": "Strg",
    "OSLeft": "OSLinks",
    "OSRight": "OSRechts",
    "ShiftLeft": "ShiftLinks",
    "ShiftRight": "ShiftRechts",
    "ContextMenu": "Menü-Taste",
    "Enter": "Enter",
    "Space": "Leertaste",
    "Tab": "Tabulator",
    "Delete": "Entf",
    "End": "Ende",
    "Help": "Hilfe",
    "Home": "Pos1",
    "Insert": "Einf",
    "PageDown": "Bild Unten",
    "PageUp": "Bild Oben",
    "ArrowDown": "Pfeil nach unten",
    "ArrowLeft": "Pfeil nach links",
    "ArrowRight": "Pfeil nach rechts",
    "ArrowUp": "Pfeil nach oben",
    "Escape": "Escape",
    "PrintScreen": "Druck",
    "ScrollLock": "Rollen",
    "Pause": "Pause",
    "Put the videos side by side": "Videos nebeneinander platzieren",
    "Minimize video": "Video minimieren",
    "Close video": "Video schließen",
    "Place the video on the other side of the screen": "Das Video auf die andere Bildschirmseite platzieren",
    "Maximize video": "Video maximieren",
    "Swap position of the videos": "Videopositionen tauschen",
    "loadManifest(): Invalid current player state: $1": "loadManifest(): Aktueller Wiedergabestatus ungültig: $1",
    "loadPlayer(): Invalid current player state: $1": "loadPlayer(): Aktueller Wiedergabestatus ungültig: $1",
    "Could not load player: state transition in progress: $1": "Player konnte nicht geladen werden: Statusübergang in Arbeit: $1",
    "Could not unload player: state transition in progress: $1": "Player konnte nicht entfernt werden: Statusübergang in Arbeit: $1",
    "unloadManifest(): Invalid current player state: $1": "unloadManifest(): Aktuell ungültiger Player-Status: $1",
    "Error loading video manifest: $1 $2": "Fehler beim Laden der Videoinformationen: $1 $2",
    "Play/pause": "Wiedergabe/Pause",
    "Select the active audio track": "Aktive Audiospur auswählen",
    "Toggle audio mute": "Audio-Stummschaltung umschalten",
    "Toggle play/pause": "Wiedergabe/Pause umschalten",
    "Toggle captions": "Untertitel umschalten",
    "Backward $1 seconds": "Zurück $1 Sekunden",
    "Forward $1 seconds": "Vorwärts $1 Sekunden",
    "Volume up 10%": "Lautstärke um 10% erhöhen",
    "Volume down 10%": "Lautstärke um 10% verringern",
    "Close pop-up": "Pop-up Fenster schließen",
    "Decrease playback speed": "Wiedergabegeschwindigkeit verringern",
    "Increase playback speed": "Wiedergabegeschwindigkeit erhöhen",
    "Swap between side by side and minimized video": "Wechsel zwischen Video nebeneinander und minimiert",
    "Swap the position of the videos": "Wechsel der Videopositionen",
    "Dual stream 50%": "Dual-Stream 50%",
    "Two videos 50%": "Zwei Videos 50%",
    "Play": "Abspielen",
    "Play/Pause button": "Wiedergabe/Pause-Schaltfläche",
    "Starts and stops video playback. When the video reaches the end, this button also allows you to restart playback from the beginning.": "Startet und stoppt die Videowiedergabe. Wenn das Video zu Ende ist, ermöglicht diese Schaltfläche auch, die Wiedergabe von Anfang an neu zu starten.",
    "Toolbar": "Symbolleiste",
    "Left-side buttons": "Schaltflächen links",
    "Right-side buttons": "Schaltflächen rechts",
    "Back": "Zurück",
    "playPauseButtonHelp.title": "Hilfe zur Wiedergabe/Pause-Schaltfläche",
    "playPauseButtonHelp.description": "Mit dieser Schaltfläche können Sie das Video abspielen oder pausieren.",
    "Options": "Optionen",
    "Configuration options": "Konfigurationsoptionen",
    "Settings": "Einstellungen",
    "Settings options": "Einstellungsoptionen"
}